// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetContactIdMappingByIdRequestModel from '../../model/get-contact-id-mapping-by-id-request-model';
import GetContactIdMappingByIdRequestDTO from '../dto/get-contact-id-mapping-by-id-request-dto';

export default abstract class GetContactIdMappingByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetContactIdMappingByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  'id'?: number;

  static toModel(dto: DeepPartial<GetContactIdMappingByIdRequestDTO>): GetContactIdMappingByIdRequestModel;
  static toModel(dto: DeepPartial<GetContactIdMappingByIdRequestDTO> | undefined | null): GetContactIdMappingByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetContactIdMappingByIdRequestDTO> | undefined | null): GetContactIdMappingByIdRequestModel | undefined {
    return dto ? new GetContactIdMappingByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetContactIdMappingByIdRequestModel> | GetContactIdMappingByIdRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
    } as GetContactIdMappingByIdRequestDTO;
  }
}
